import { faClose, faSave, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, IconButton, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useRef } from "react";
import { useForm } from "../../../../components/FormProvider";
import { Child, Family } from "../../../../models";

export function AddChildForm(props: {
  family: Family;
  resetFormRef: React.RefObject<(() => void) | null>;
  dataGetterRef: React.RefObject<(() => Child | null) | null>;
}) {
  const { family } = props;
  const form = useForm();

  // use refs for the text fields to improve performance. otherwise every character entered/deleted causes a re-render, making it feel very slow
  // it's not as noticable with the other types of inputs, so we don't need to make those ref based.
  const firstNameField = useRef<HTMLInputElement | null>(null);
  const lastNameField = useRef<HTMLInputElement | null>(null);

  const resetForm = (): void => {
    if (firstNameField.current) {
      firstNameField.current.value = "";
    }
    if (lastNameField.current) {
      lastNameField.current.value = family.name ?? "";
    }
  };

  const getUpdatedRecord = (): Child => {
    return {
      id: 0,
      familyId: family.id,
      deleted: false,
      isActive: true,
      isTrained: false,
      isTraining: false,
      stage: "Infant",
      stageDisplayName: "Infant",
      weeklyRate: 0,
      firstName: firstNameField?.current?.value ?? "",
      lastName: lastNameField?.current?.value ?? "",
    };
  };

  useEffect(() => {
    if (props.dataGetterRef) {
      props.dataGetterRef.current = getUpdatedRecord;
    }
    if (props.resetFormRef) {
      props.resetFormRef.current = resetForm;
    }
  });

  return (
    <Stack gap={2} flexGrow={1}>
      <Stack direction="row" alignItems="center">
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          Add Child
        </Typography>
        <IconButton sx={{ width: 44, height: 44 }} onClick={form.cancel}>
          <FontAwesomeIcon icon={faClose} />
        </IconButton>
      </Stack>

      <Stack sx={{ alignItems: { xs: "center", md: "flex-start" } }} flexGrow={1}>
        <Stack gap={1} flexGrow={1} width="100%">
          <TextField variant="filled" label="First Name" defaultValue={""} inputRef={firstNameField} disabled={form.isDisabled} />
          <TextField variant="filled" label="Last Name" defaultValue={family?.name ?? ""} inputRef={lastNameField} disabled={form.isDisabled} />
        </Stack>
      </Stack>

      <Button variant="contained" onClick={form.save} sx={{ height: 50, width: { xs: "100%", md: "inherit" } }} startIcon={<FontAwesomeIcon icon={faSave} />}>
        Save
      </Button>

      <Button
        variant="outlined"
        color="error"
        onClick={form.cancel}
        sx={{ height: 50, width: { xs: "100%", md: "inherit" } }}
        startIcon={<FontAwesomeIcon icon={faTimes} />}
      >
        Cancel
      </Button>
    </Stack>
  );
}
